import { render } from "./AddLohnastus.vue?vue&type=template&id=cca92338&scoped=true"
import script from "./AddLohnastus.vue?vue&type=script&lang=js"
export * from "./AddLohnastus.vue?vue&type=script&lang=js"

import "./AddLohnastus.vue?vue&type=style&index=0&id=cca92338&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca92338"]])

export default __exports__